import { siteConfig, standaloneSite } from "../../site-config/SiteConfig";
import { getStandaloneSpaceId } from "../config";
import type { MembershipProduct } from "../../platform_spaces/space/SpaceType";
import { SpaceProductPurchaseModal } from "../../platform_spaces/space/components/SpaceProductPurchaseModal";

type Props = {
  row: MembershipProduct;
  open: boolean;
  onClose: () => void;
  isLoggedIn: boolean;
  onLoginRequest: () => void;
  prefillStraId?: string;
};

/** 独立站：产品购买弹窗（策略/会员共用同一套布局） */
export function StandaloneProductPurchaseModal(props: Props): JSX.Element {
  const { row, open, onClose, isLoggedIn, onLoginRequest, prefillStraId } = props;
  const spaceId = getStandaloneSpaceId();
  const brandName = siteConfig.shellBrandNavLabel || standaloneSite.brandName;

  return (
    <SpaceProductPurchaseModal
      spaceId={spaceId}
      row={row}
      open={open}
      onClose={onClose}
      isLoggedIn={isLoggedIn}
      onLoginRequest={onLoginRequest}
      spaceProfile={null}
      prefillStraId={prefillStraId}
      standaloneBrand={{
        logoUrl: siteConfig.shellLogo,
        brandName,
        slogan: standaloneSite.slogan,
        spaceIdLabel: spaceId,
      }}
      checkoutPath={(orderId) => `/tactik/checkout/${encodeURIComponent(orderId)}`}
    />
  );
}
